import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';

import { EditAdminForm } from '../../components/EditAdminForm';
import { theme } from '../../services/theme';
import { admin } from '../../services/user';
import { useGetWorkbetterAdminsList } from '../../services/user/hooks/useGetWorkbetterAdminsList';

export const EditWorkBetterAdmin = () => {
  const navigate = useNavigate();

  const params = useParams();
  const adminId = params.adminId;

  const { getAdminsList } = useGetWorkbetterAdminsList();
  const [editAdmin, setEditAdmin] = useState<admin>({} as admin);

  useEffect(() => {
    const adminList = getAdminsList?.items as admin[];
    adminList?.forEach((adminItem) => {
      if (adminId && adminItem.id == parseInt(adminId.toString())) {
        setEditAdmin(adminItem);
      }
    });
  }, [getAdminsList, adminId]);

  const { refetchAdminsList } = useGetWorkbetterAdminsList();
  const goBack = (navigate: NavigateFunction) => navigate('/settings');

  const onGoBack = (navigate: NavigateFunction) => () => {
    refetchAdminsList();
    goBack(navigate);
  };

  return (
    <>
      <Helmet>
        <title>Edit WorkBetter Admin</title>
      </Helmet>
      <Typography
        sx={{
          marginBottom: '20px',
          marginTop: '15px',
        }}
        variant="h1"
      >
        Edit WorkBetter admin
      </Typography>
      {editAdmin.email && (
        <EditAdminForm
          editAdmin={editAdmin}
          onCancel={onGoBack(navigate)}
          onSuccess={onGoBack(navigate)}
        />
      )}
    </>
  );
};
export default EditWorkBetterAdmin;
